module.exports = __webpack_public_path__ + "d8c6a3cac43e6a66c16a1e90493da528.jpg";